<h1 mat-dialog-title>Artikel bearbeiten</h1>

<mat-dialog-content>
    <ng-container *ngIf="selectedMaterial">
        <kiene-article-scan-autocomplete
            #articleScanAutocompleteEdit
            (selectedMaterial)="setSelectedMaterial($event)"
            [focus]="true"
            [placeholder]="'Artikel eingeben oder scannen'"
            [presetMaterial]="selectedMaterial"
        >
        </kiene-article-scan-autocomplete>

        <mat-form-field style="width: 100%">
            <mat-label>Menge</mat-label>
            <input [formControl]="mengeCtrl" matInput required type="number" />
        </mat-form-field>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button (click)="dialogRef.close()" mat-button>Abbrechen</button>
    <button (click)="save()" [disabled]="!selectedMaterial && mengeCtrl.invalid" color="accent" mat-flat-button>
        Speichern
    </button>
</mat-dialog-actions>
